import React, { useEffect, useState, useRef, useCallback } from "react";

/** Components */
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, CircularProgress, Divider, Typography } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { FilterBy } from "./../commons/filter.component";

/** Api and components */
import { getInvoiceYearly, getOrganizationData, getrptyearly, getRPTYearlyByWH } from "./../../services/api";

/**Package */
import moment from "moment";

/**Hook */

import { statusColor } from "./../config";
import { useTranslation } from "react-i18next";

const options = {
  scales: {
    y: {
      beginAtZero: true,
    },
  },
};
const initialFilter = {
  startDate: "",
  endDate: "",
  organization: null,
};

const Dashboard = () => {
  const [invoiceData, setInvoiceData] = useState("loading");
  const [ticketData, setTicketData] = useState("loading");
  const [ticketTableData, setTicketTableData] = useState();
  const [filter, setFilter] = useState({
    ...initialFilter,
    endDate: moment(Date.now()).format("YYYY-MM"),
    startDate: moment(Date.now()).format("YYYY-01"),
  });
  const filterRef = useRef();

  const handleSearch = () => {
    setInvoiceData("loading");
    setTicketData("loading");
    let object = {};
    if (filter.startDate) object.start_date = moment(filter.startDate).startOf("month").format("YYYY-MM-DD");
    if (filter.endDate) object.end_date = moment(filter.endDate).endOf("month").format("YYYY-MM-DD");
    if (filter.organization) object.organization_id = filter.organization.id;
    getrptyearly(object).then((res) => {
      res.code === 200 && setTicketData(Boolean(Object.keys(res.data).length) ? res.data : false);
    });
    getInvoiceYearly(object).then((res) => {
      res.code === 200 && setInvoiceData(Boolean(Object.keys(res.data).length) ? res.data : false);
    });
    getRPTYearlyByWH(object).then((res) => {
      res.code === 200 && setTicketTableData(res.data);
    });
  };
  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    filterRef.current = filter;
  }, [filter]);

  return (
    <div style={{ margin: 20, width: "96%" }}>
      {/* filter */}
      <div style={{ display: "flex", justifyContent: "right" }}>
        <TextField
          type="month"
          value={filter.startDate}
          label="Từ tháng"
          style={{ margin: "0 5px" }}
          id="from_date"
          onChange={(e) =>
            setFilter((prev) => ({
              ...prev,
              startDate: e.target.value,
              endDate:
                moment(prev.endDate) > moment(e.target.value).add(11, "month") || moment(prev.endDate) < moment(e.target.value)
                  ? moment(e.target.value).add(11, "month").format("YYYY-MM")
                  : prev.endDate,
            }))
          }
        />
        <TextField
          type="month"
          value={filter.endDate}
          label="Đến tháng"
          id="to_date"
          style={{ margin: "0 5px" }}
          onChange={(e) =>
            setFilter((prev) => ({
              ...prev,
              endDate: e.target.value,
              startDate:
                moment(prev.startDate).add(11, "month") < moment(e.target.value) || moment(prev.startDate) > moment(e.target.value)
                  ? moment(e.target.value).subtract(11, "month").format("YYYY-MM")
                  : prev.startDate,
            }))
          }
        />
        <FilterBy
          style={{ minWidth: 250 }}
          label="Tổ chức"
          getDataFunc={() => getOrganizationData({ status: 1 })}
          value={filter.organization}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, organization: newValue }))}
        />
        <Button variant="contained" onClick={handleSearch} style={{ margin: "0 5px" }}>
          Tìm kiếm
        </Button>
      </div>
      <div>
        <div style={{ display: "flex", justifyContent: "left" }}>
          <Typography>THÔNG TIN SỬ DỤNG HOÁ ĐƠN ĐIỆN TỬ</Typography>
        </div>
        <Divider textAlign="left" style={{ marginBottom: 10 }} />
        <Chart1 initialData={invoiceData} tableData={ticketTableData} startDate={filter.startDate} endDate={filter.endDate} />
        <div style={{ display: "flex", justifyContent: "left", marginTop: 20 }}>
          <Typography>THÔNG TIN SỬ DỤNG PHIẾU XUẤT KHO KIÊM VẬN CHUYỂN NỘI BỘ</Typography>
        </div>
        <Divider textAlign="left" style={{ marginBottom: 10 }} />
        <Chart2 initialData={ticketData} />
      </div>

      {/* <Chart2 initialData={initialData2}/> */}
    </div>
  );
};
export default Dashboard;

const Chart1 = React.memo((props) => {
  const [t] = useTranslation();
  const convertData = (data) => {
    const months = Object.keys(data); //[10-2021, 11-2021]
    let datasets = [];
    //label[key] la array
    months.forEach((month) => {
      Object.keys(data[month]).forEach((status) => {
        let index = datasets.findIndex((sub_item) => t(sub_item.label) === t(status));
        if (index !== -1) {
          datasets[index].data.push(data[month][status]);
        } else {
          datasets.push({
            label: t(status),
            data: [data[month][status]],
            backgroundColor: statusColor[status],
          });
        }
      });
    });
    return {
      labels: months,
      datasets,
    };
  };
  switch (props.initialData) {
    case false:
      return <div>No data found</div>;
    case "loading":
      return <CircularProgress />;
    default:
      return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: 40 }}>
          <div style={{ width: "100%" }}>
            <Bar data={convertData(props.initialData)} options={options} />
          </div>
          <RPTTable {...props} />
        </div>
      );
  }
});
const Chart2 = React.memo((props) => {
  const [t] = useTranslation();
  const { initialData } = props;
  const convertData = (data) => {
    const months = Object.keys(data); //[10-2021, 11-2021]
    let datasets = [];
    //label[key] la array
    months.forEach((month) => {
      Object.keys(data[month]).forEach((status) => {
        let index = datasets.findIndex((sub_item) => t(sub_item.label) === t(status));
        if (index !== -1) {
          datasets[index].data.push(data[month][status]);
        } else {
          datasets.push({
            label: t(status),
            data: [data[month][status]],
            backgroundColor: statusColor[status],
          });
        }
      });
    });
    return {
      labels: months,
      datasets,
    };
  };
  const getTotal = () => {
    let total = {};
    if (!initialData) return;
    Object.keys(initialData)?.forEach((month) => {
      Object.keys(initialData[month]).forEach((status) => {
        total[status] = (total[status] || 0) + initialData[month][status];
      });
    });
    return total;
  };
  switch (props.initialData) {
    case false:
      return <div>No data found</div>;
    case "loading":
      return <CircularProgress />;
    default:
      return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: 40 }}>
          <div style={{ width: "100%" }}>
            <Bar data={convertData(props.initialData)} options={options} />
          </div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "1px solid lightgray" }}></TableCell>
                  {initialData &&
                    Object.keys(initialData[Object.keys(initialData)[0]])
                      .sort()
                      .map((status) => (
                        <TableCell align="center" style={{ border: "1px solid lightgray" }} key={status}>
                          {t(status)}
                        </TableCell>
                      ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {initialData &&
                  Object.keys(initialData).map((month) => (
                    <TableRow key={month}>
                      <TableCell align="center" style={{ border: "1px solid lightgray" }}>
                        {month || ""}
                      </TableCell>
                      {Object.keys(initialData[month])
                        .sort()
                        .map((status) => (
                          <TableCell key={status} align="center" style={{ border: "1px solid lightgray" }}>
                            {initialData[month][status]?.toLocaleString()}
                          </TableCell>
                        ))}
                    </TableRow>
                  ))}
                <TableRow>
                  <TableCell style={{ border: "1px solid lightgray", fontWeight: "bold" }}>Tổng cộng</TableCell>
                  {Object.keys(getTotal())
                    .sort()
                    .map((status) => (
                      <TableCell key={status} style={{ border: "1px solid lightgray", fontWeight: "bold" }}>
                        {getTotal()[status]?.toLocaleString()}
                      </TableCell>
                    ))}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      );
  }
});
const RPTTable = ({ tableData, startDate, endDate }) => {
  const { t } = useTranslation();
  const monthArrays = useCallback(() => {
    // ['01-2022', '02-2022',...]
    const start_date = moment(startDate);
    const array = [];
    while (!moment(start_date).isAfter(moment(endDate))) {
      array.push(start_date.format("MM-YYYY"));
      start_date.add(1, "month");
    }
    return array;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);
  if (tableData)
    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ border: "1px solid lightgray" }}>STT</TableCell>
              <TableCell style={{ border: "1px solid lightgray" }}>{t("Kho hàng")}</TableCell>
              {monthArrays().map((month) => (
                <TableCell key={month} style={{ border: "1px solid lightgray" }}>
                  {month}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(tableData).map((org, index) => (
              <TableRow key={index}>
                <TableCell style={{ border: "1px solid lightgray" }}>{index + 1}</TableCell>
                <TableCell style={{ border: "1px solid lightgray" }}>{org}</TableCell>
                {monthArrays().map((month) => (
                  <TableCell key={month} style={{ border: "1px solid lightgray" }}>
                    {(tableData[org]?.[month]?.[0]?.count || 0).toLocaleString()}
                  </TableCell>
                ))}
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={2} style={{ border: "1px solid lightgray", fontWeight: "bold" }}>
                Tổng cộng
              </TableCell>
              {monthArrays().map((month) => (
                <TableCell key={month} style={{ border: "1px solid lightgray", fontWeight: "bold" }}>
                  {Object.keys(tableData)
                    .reduce((prev, next) => prev + (tableData[next]?.[month]?.[0]?.count || 0), 0)
                    .toLocaleString()}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  return "";
};
